import type { RhinoImage, RhinoImageRatio } from '../../data';

type Params = { images: RhinoImage[]; ratio: RhinoImageRatio } & ({ width: number } | { height: number });
type Result = {
  url?: string;
  width: number;
  height: number;
};

export function pickImageByRatio(params: Params): Result {
  const image =
    params.images.length > 0
      ? params.images.find((image) => image.ratio === params.ratio) ?? params.images[0]
      : undefined;

  let width, height;
  if ('width' in params) {
    width = params.width;
    height = getHeightByWidth(params.width, params.ratio);
  } else {
    width = getWidthByHeight(params.height, params.ratio);
    height = params.height;
  }

  return { url: image ? calcImageUrl(image.url, height, width) : undefined, width, height };
}
// TODO: move into data/images
export function getWidthByHeight(height: number, ratio: string): number {
  const [widthRatio, heightRatio] = ratio.split(/:|x/).map(Number);
  return (height / heightRatio) * widthRatio;
}

export function getHeightByWidth(width: number, ratio: string): number {
  const [widthRatio, heightRatio] = ratio.split(/:|x/).map(Number);
  return (width / widthRatio) * heightRatio;
}

export function calcImageUrl(url: string, height: number, width: number): string {
  return `${url}/height/${Math.ceil(height)}/width/${Math.ceil(width)}`;
}
